import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HoodieOrNah from './HoodieOrNah';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HoodieOrNah />
  </React.StrictMode>
);